import React from 'react';
import { Box, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { margin } from '@mui/system';

export default function ShiftPlanManagementDialogHeader({ currentDate, handlePreviousDay, handleNextDay, handleClose, showTimeblocks }) {
    const closeIconStyle = {
        minHeight: '2rem',
        minWidth: '2rem',
        paddingRight: '1rem',
        width: '2rem',
        position: 'absolute',
        right: '8px',
        top: '8px'
    };

    return <Box display="flex" alignItems="center">
            <Button onClick={handlePreviousDay} variant="contained" size="small" style={{ marginRight: '1rem' }}>&lt;&lt; Previous Day</Button>
            {currentDate}
            <Button onClick={handleNextDay} variant="contained" size="small" style={{ marginLeft: '1rem' }}>Next Day &gt;&gt;</Button>
            <Button  size="small" sx={{...closeIconStyle}} onClick={handleClose} endIcon={<CloseIcon />} />
    </Box>
};